export class Assignation {
    public assignmentId: number
    public companyId: number
    public userId: number
    public tillId: number
    public userFirstname?: string
    public userLastname?: string
    public userPhone?: string
    public tillName?: string
    public tillState?: string
    public startDate?: Date
    public endDate?: Date

    constructor(args: {
        assignmentId: number,
        companyId: number,
        userId: number,
        tillId: number,
        userFirstname?: string,
        userLastname?: string,
        userPhone?: string,
        tillName?: string,
        tillState?: string,
        startDate?: Date,
        endDate?: Date
    }) {

        this.assignmentId = args.assignmentId
        this.companyId = args.companyId
        this.userId = args.userId
        this.tillId = args.tillId
        this.userFirstname = args.userFirstname
        this.userLastname = args.userLastname
        this.userPhone = args.userPhone
        this.tillName = args.tillName
        this.tillState = args.tillState
        this.startDate = args.startDate
        this.endDate = args.endDate
    }

    static fromJSON(jsonData: any): Assignation {
        return new Assignation({
            assignmentId: jsonData.assignment_id,
            companyId: jsonData.company_id,
            userId: jsonData.user_id,
            tillId: jsonData.till_id,
            userFirstname: jsonData.user_firstname,
            userLastname: jsonData.user_lastname,
            userPhone: jsonData.user_phone,
            tillName: jsonData.till_name,
            tillState: jsonData.till_state,
            startDate: jsonData.start_date ? new Date(jsonData.start_date) : undefined,
            endDate: jsonData.end_date ? new Date(jsonData.end_date) : undefined
        })
    }
}
